module.exports = __webpack_public_path__ + "static/media/didaima7.7c520c0.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/didaima7.mp4
// module id = E8sE
// module chunks = 0